import React from 'react';

function ColorSettings({ settings, setSettings }) {
  return (
    <div className="editor-section">
      <h3>🎨 Color Settings</h3>
      <div className="form-group">
        <label>Primary Color</label>
        <input type="color" value={settings.primaryColor} onChange={(e) => setSettings({...settings, primaryColor: e.target.value})} className="form-input" style={{height:'40px'}} />
        <small>Used for buttons, links, highlights</small>
      </div>
      <div className="form-group">
        <label>Secondary Color</label>
        <input type="color" value={settings.secondaryColor} onChange={(e) => setSettings({...settings, secondaryColor: e.target.value})} className="form-input" style={{height:'40px'}} />
        <small>Used for accents, hover states</small>
      </div>
      <div className="form-group">
        <label>Body Background Color</label>
        <input type="color" value={settings.bodyBgColor} onChange={(e) => setSettings({...settings, bodyBgColor: e.target.value})} className="form-input" style={{height:'40px'}} />
      </div>
    </div>
  );
}

export default ColorSettings;